<template>
  <div>
    <header-component id="headerComponent" ref="headerComponent"></header-component>
    <router-view></router-view>
    <footer-component id="footerComponent" ref="footerComponent"></footer-component>
  </div>
</template>

<script>
  import Header from './components/Header.vue';
  import Footer from './components/Footer.vue';

  export default {
    name: 'app',
    components: {
      'header-component': Header,
      'footer-component': Footer
    }
  }
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/App.vue